<div>
  <label class="bold">
    {{ label }}
    <span *ngIf="required">*</span>
  </label>
  <select
    class="form-select"
    [ngModel]="selectedTeacherId"
    (ngModelChange)="onTeacherChange($event)"
    [disabled]="disabled"
  >
    <option *ngIf="allowAllOption" [ngValue]="0">All</option>
    <option *ngFor="let teacher of teachers" [ngValue]="teacher.userID">
      {{ teacher.firstName }} {{ teacher.lastName }}
    </option>
  </select>
</div>
